

















































































































// decoradores
import { Vue, Component } from "vue-property-decorator";
// vuex
import { mapActions, mapGetters } from "vuex";
// tipos

// componentes
import TablaCondicionDivision from "@/components/condicionesDivisiones/Tabla.vue";
import FormularioCondicionDivision from "@/components/condicionesDivisiones/Formulario.vue";
import { DataFormularioCondicionDivision } from "@/typings/components/condicionesDivisiones/formulario";
import DialogoExito from "@/components/DialogoExito.vue";
import DialogoEliminar from "@/components/DialogoEliminar.vue";
import InfoCondicionDivision from "@/components/condicionesDivisiones/Info.vue";
//import BotonesCrud from "@/components/BotonesCrud.vue";
import MensajeEliminar from "@/components/MensajeEliminar.vue";
//import TituloVista from "@/components/TituloVista.vue";
import {
  CondicionDivision,
  CondicionesDivisiones,
  //  Regiones,
} from "@/typings/store/plugins/easyFirestore/condicionesDivisiones";
import ExportarExcelGenerico from "@/components/ExportarExcelGenerico.vue";
import ExportarPdfGenerico from "@/components/ExportarPdfGenerico.vue";

const routeGuard = (vm: Vue): boolean => {
  const permisos = vm.getUsuario?.permisos;
  if (permisos && permisos["condicionesDivisiones"]) {
    return true;
  }

  const rutas = vm.getRutasUsuario;
  if (rutas.length > 0) {
    const to = rutas[0].to;
    if (to) {
      if (vm.$route.name !== to.name) {
        vm.$router.replace(to);
      }
      return false;
    }
  }
  if (vm.$route.name !== "inicio") {
    vm.$router.replace({ name: "inicio" });
  }
  return false;
};

@Component({
  computed: mapGetters({
    getUsuarios: "usuarios/get",
    getCondicionesDivisiones: "condicionesDivisiones/get",
    getArrayUsuarios: "usuarios/getArray",
    getUsuario: "usuario/get",
    getRutas: "rutas/get",
    getRutasUsuario: "usuario/getRutas",
    getArrayCondicionesDivisiones: "condicionesDivisiones/getArray",
  }),
  methods: mapActions({
    setCondicionDivision: "condicionesDivisiones/set",
    deleteCondicionDivision: "condicionesDivisiones/delete",
    //insertBatchBancos: "condicionesDivisiones/insertBatch",
    //setArchivo: "archivos/set",
    //deleteArchivo: "archivos/delete",
  }),
  beforeRouteEnter(to, from, next) {
    next(routeGuard);
  },
  components: {
    DialogoEliminar,
    DialogoExito,
    TablaCondicionDivision,
    FormularioCondicionDivision,
    InfoCondicionDivision,
    MensajeEliminar,
    ExportarExcelGenerico,
    ExportarPdfGenerico,
  },
})
export default class VistaCondicionDivision extends Vue {
  created(): void {
    if (!routeGuard(this)) {
      return;
    }
  }

  cargando = false;
  dialogoExito = {
    model: false,
    texto: "",
    icono: "",
  };
  search = "";
  condicionDivision: CondicionDivision | null = null;
  dialogoInfo = false;
  dialogoFormulario = false;
  dialogoEliminar = false;
  textoEliminar = "¿ESTÁS SEGURO QUE DESEAS ELIMINAR ESTA CONDICIÓN?";
  dialogoCargarExcel = false;

  get condicionesDivisiones(): CondicionesDivisiones {
    return this.getCondicionesDivisiones;
  }

  get items(): Array<CondicionDivision> {
    return this.getArrayCondicionesDivisiones;
  }

  get columnasExportacionCondicionesDivisiones(): Array<{ label: string; field: string }> {
    return [
      { label: "Código división", field: "codigo_division" },
      { label: "Nombre división", field: "nombre_division" },
      { label: "Moneda", field: "moneda" },
      { label: "Escala", field: "escala" },
      { label: "Indexación", field: "indexacion" },
      { label: "Mínimo", field: "minimo" },
      { label: "Aporte", field: "aporte" },
      { label: "Operador", field: "operador" },
      { label: "Origen", field: "origen" },
      { label: "Código contrato", field: "codigo_contrato" },
      { label: "Código condición", field: "codigo_condicion" },
    ];
  }

  clickItem(val: { id: string } | null): void {
    this.condicionDivision = val ? this.condicionesDivisiones[val.id] : null;
  }

  clickPlus(): void {
    this.condicionDivision = null;
    this.dialogoFormulario = true;
  }

  async clickGuardar(data: DataFormularioCondicionDivision): Promise<void> {
    this.cargando = true;
    const doc = data.doc;
    await this.setCondicionDivision(doc);
    if (doc.id != this.condicionDivision?.id) {
      this.dialogoExito = {
        model: true,
        texto: "¡Condición creada con éxito!",
        icono: require("../assets/icons/double-check-duo.svg"),
      };
    }
    if (doc.id == this.condicionDivision?.id) {
      this.dialogoExito = {
        model: true,
        texto: "¡Condición editada con éxito!",
        icono: require("../assets/icons/editar.svg"),
      };
      this.condicionDivision = doc;
    }
    this.cerrarDialogoFormulario();
    this.cargando = false;
  }

  cerrarDialogoExito(): void {
    this.dialogoExito = {
      model: false,
      texto: "",
      icono: "",
    };
  }

  clickEliminar(): void {
    const condicionDivision = this.condicionDivision;
    if (!condicionDivision?.id) {
      console.error("error id: ", condicionDivision);
      return;
    }
    this.deleteCondicionDivision(condicionDivision.id);
    this.condicionDivision = null;
    this.cerrarDialogoEliminar();
  }

  abrirDialogoInfo(condicionDivision: CondicionDivision): void {
    if (!condicionDivision.id) {
      console.error("error id: ", condicionDivision);
      return;
    }
    const doc = this.condicionesDivisiones[condicionDivision.id];
    if (doc) {
      this.condicionDivision = doc;
      this.dialogoInfo = true;
    }
  }

  cerrarDialogoInfo(): void {
    this.dialogoInfo = false;
    this.condicionDivision = null;
  }

  abrirDialogoFormulario(condicionDivision: CondicionDivision): void {
    if (!condicionDivision.id) {
      console.error("error id: ", condicionDivision);
      return;
    }
    const doc = this.condicionesDivisiones[condicionDivision.id];
    if (doc) {
      this.condicionDivision = doc;
      this.dialogoFormulario = true;
    }
  }

  abrirDialogoEliminar(condicionDivision: CondicionDivision): void {
    if (!condicionDivision.id) {
      console.error("error id: ", condicionDivision);
      return;
    }
    const doc = this.condicionesDivisiones[condicionDivision.id];
    if (doc) {
      this.dialogoEliminar = true;
      this.condicionDivision = doc;
    }
  }

  cerrarDialogoEliminar(): void {
    this.dialogoEliminar = false;
    this.condicionDivision = null;
  }

  cerrarDialogoFormulario(): void {
    this.dialogoFormulario = false;
    this.condicionDivision = null;
  }
}
